export default {
  namespaced: true,
  state: {
    event: null,
    score: null,
    audio: null,
    video: null,
  },
  getters: {},
  mutations: {
    setEvent(state, event) {
      state.event = event;
    },
    setScore(state, score) {
      state.score = score;
    },
    setAudio(state, audio) {
      state.audio = audio;
    },
    setVideo(state, video) {
      state.video = video;
    },
    clearEvent(state) {
      state.event = null;
    },
    clearScore(state) {
      state.score = null;
    },
    clearAudio(state) {
      state.audio = null;
    },
    clearVideo(state) {
      state.video = null;
    },
  },
  actions: {
    sendAudio({ state }, { name, phone }) {
      const { audio } = state;
      return this.$axios.post('/feedback/building', {
        feedback: {
          name,
          phone_number: phone,
          audio_file_link: audio?.fullPath,
        },
      });
    },
    sendVideo({ state }, { name, phone }) {
      const { video, score, event } = state;
      return this.$axios.post('/feedback/performance', {
        feedback: {
          name,
          phone_number: phone,
          video_file_link: video?.fullPath,
          event_date: event?.date,
          performance_name: event?.performance?.title,
          rate: score,
        },
      });
    },
  },
};
